import { Text } from '#app/components/Primitives/Text.js';
import { LightbulbEmoji } from '@contra/icons/emojis';
import { css, styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${theme.colorsV2.gray10};
    padding: 16px;
    gap: 8px;
    width: 100%;
  `};
`;

export const ProductizedServicePreviewBanner = () => {
  return (
    <Container>
      <LightbulbEmoji size={24} />

      <Text textStyle="bodyRegular">
        This is what your service will look like.
      </Text>
    </Container>
  );
};
